export const DEAL_STAGE = {
  CONTATTARE_CLIENTE: '257127884',
  APPUNTAMENTO_DA_CONFERMARE: '257127885',
  APPUNTAMENTO_CONFERMATO: '257127886',
  APPUNTAMENTO_ANNULLATO_STB_15GG: '337244912',
  IN_SVILUPPO: '267134394',
  INCARICO_O_VOUCHER_OTTENUTO: '257127887',
  IN_ATTESA_DI_DELIBERA: '257127888',
  DELIBERATA: '500935619',
  INCARICO_VOUCHER_OTTENUTO: '5050432716',
  IN_ATTESA_DELIBERA_VOUCHER: '5052789994',
  DELIBERATA_VOUCHER: '5052789995',
  ATTO_FISSATO: 'closedwon',
  ATTO_NOTARILE_CONCLUSO: '257127889',
  DROPPED: '255358657',
  APPUNTAMENTO_DA_RIFISSARE: '417544934',
} as const;

export function translateDealStage( dealStage:string|null|undefined ) {
  switch (dealStage) {
    case '257127884': 
      return {
        label: 'Contattare cliente',
        value: DEAL_STAGE.CONTATTARE_CLIENTE,
      };
    case '257127885': 
      return {
        label: 'Appuntamento da confermare',
        value: DEAL_STAGE.APPUNTAMENTO_DA_CONFERMARE,
      };
    case '257127886': 
      return {
        label: 'Appuntamento confermato',
        value: DEAL_STAGE.APPUNTAMENTO_CONFERMATO,
      };
    case '337244912': 
      return {
        label: 'Il cliente non risponde',
        value: DEAL_STAGE.APPUNTAMENTO_ANNULLATO_STB_15GG,
      };
    case '267134394': return { label: 'In sviluppo', value: DEAL_STAGE.IN_SVILUPPO };
    case '257127887':
      return {
        label: 'Incarico ottenuto',
        value: DEAL_STAGE.INCARICO_O_VOUCHER_OTTENUTO,
      };
    case '257127888':
      return {
        label: 'In attesa di delibera',
        value: DEAL_STAGE.IN_ATTESA_DI_DELIBERA,
      };
    case '500935619':
      return {
        label: 'Deliberata',
        value: DEAL_STAGE.DELIBERATA,
      };
    case '5050432716':
      return {
        label: 'Incarico ottenuto - Voucher',
        value: DEAL_STAGE.INCARICO_VOUCHER_OTTENUTO,
      };
    case '5052789994':
      return {
        label: 'In attesa delibera - Voucher',
        value: DEAL_STAGE.IN_ATTESA_DELIBERA_VOUCHER,
      };
    case '5052789995':
      return {
        label: 'Deliberata - Voucher',
        value: DEAL_STAGE.DELIBERATA_VOUCHER,
      };
    case 'closedwon': return { label: 'Atto Fissato', value: DEAL_STAGE.ATTO_FISSATO };
    case '257127889': 
      return {
        label: 'Atto Notarile concluso',
        value: DEAL_STAGE.ATTO_NOTARILE_CONCLUSO,
      };
    case '255358657': return { label: 'Dropped', value: DEAL_STAGE.DROPPED };
    case '417544934': 
      return {
        label: 'Appuntamento da rifissare',
        value: DEAL_STAGE.APPUNTAMENTO_DA_RIFISSARE,
      };
    default:
      return {
        label: dealStage,
        value: dealStage
      }
  }
};

export const DEAL_STAGE_LABEL_VALUE_OBJ = {
  CONTATTARE_CLIENTE: {
    label: 'Contattare cliente',
    value: DEAL_STAGE.CONTATTARE_CLIENTE,
  },
  APPUNTAMENTO_DA_CONFERMARE: {
    label: 'Appuntamento da confermare',
    value: DEAL_STAGE.APPUNTAMENTO_DA_CONFERMARE,
  },
  APPUNTAMENTO_CONFERMATO: {
    label: 'Appuntamento confermato',
    value: DEAL_STAGE.APPUNTAMENTO_CONFERMATO,
  },
  APPUNTAMENTO_ANNULLATO_STB_15GG: {
    label: 'Il cliente non risponde',
    value: DEAL_STAGE.APPUNTAMENTO_ANNULLATO_STB_15GG,
  },
  IN_SVILUPPO: { label: 'In sviluppo', value: DEAL_STAGE.IN_SVILUPPO },
  INCARICO_O_VOUCHER_OTTENUTO: {
    label: 'Incarico ottenuto',
    value: DEAL_STAGE.INCARICO_O_VOUCHER_OTTENUTO,
  },
  IN_ATTESA_DI_DELIBERA: {
    label: 'In attesa di delibera',
    value: DEAL_STAGE.IN_ATTESA_DI_DELIBERA,
  },
  DELIBERATA: {
    label: 'Deliberata',
    value: DEAL_STAGE.DELIBERATA,
  },
  ATTO_FISSATO: { label: 'Atto Fissato', value: DEAL_STAGE.ATTO_FISSATO },
  ATTO_NOTARILE_CONCLUSO: {
    label: 'Atto Notarile concluso',
    value: DEAL_STAGE.ATTO_NOTARILE_CONCLUSO,
  },
  DROPPED: { label: 'Dropped', value: DEAL_STAGE.DROPPED },
  APPUNTAMENTO_DA_RIFISSARE: {
    label: 'Appuntamento da rifissare',
    value: DEAL_STAGE.APPUNTAMENTO_DA_RIFISSARE,
  },
  INCARICO_VOUCHER_OTTENUTO: {
    label: 'Incarico ottenuto - Voucher',
    value: DEAL_STAGE.INCARICO_VOUCHER_OTTENUTO,
  },
  IN_ATTESA_DELIBERA_VOUCHER: {
    label: 'In attesa delibera - Voucher',
    value: DEAL_STAGE.IN_ATTESA_DELIBERA_VOUCHER,
  },
  DELIBERATA_VOUCHER: {
    label: 'Deliberata - Voucher',
    value: DEAL_STAGE.DELIBERATA_VOUCHER,
  },
};

export const DROPPED_MOTIVATION_OPTIONS = {
  CONTATTARE_CLIENTE: [
    {
      label: "Pre-appuntamento | Non si è presentato all'appuntamento",
      value: "Pre-appuntamento | Non si è presentato all'appuntamento",
    },
    {
      label: 'Pre-appuntamento | Appuntamento disdetto',
      value: 'Pre-appuntamento | Appuntamento disdetto',
    },
    {
      label: 'Post-appuntamento | Requisiti bocciati',
      value: 'Post-appuntamento | Requisiti bocciati',
    },
    {
      label: 'Post-appuntamento | Appuntamento andato male (altri motivi)',
      value: 'Post-appuntamento | Appuntamento andato male (altri motivi)',
    },
  ],
  APPUNTAMENTO_DA_CONFERMARE: [
    {
      label: "Pre-appuntamento | Non si è presentato all'appuntamento",
      value: "Pre-appuntamento | Non si è presentato all'appuntamento",
    },
    {
      label: 'Pre-appuntamento | Appuntamento disdetto',
      value: 'Pre-appuntamento | Appuntamento disdetto',
    },
    {
      label: 'Post-appuntamento | Requisiti bocciati',
      value: 'Post-appuntamento | Requisiti bocciati',
    },
    {
      label: 'Post-appuntamento | Appuntamento andato male (altri motivi)',
      value: 'Post-appuntamento | Appuntamento andato male (altri motivi)',
    },
  ],
  APPUNTAMENTO_CONFERMATO: [
    {
      label: "Pre-appuntamento | Non si è presentato all'appuntamento",
      value: "Pre-appuntamento | Non si è presentato all'appuntamento",
    },
    {
      label: 'Pre-appuntamento | Appuntamento disdetto',
      value: 'Pre-appuntamento | Appuntamento disdetto',
    },
    {
      label: 'Post-appuntamento | Requisiti bocciati',
      value: 'Post-appuntamento | Requisiti bocciati',
    },
    {
      label: 'Post-appuntamento | Appuntamento andato male (altri motivi)',
      value: 'Post-appuntamento | Appuntamento andato male (altri motivi)',
    },
  ],
  ALTRO: [
    {
      label: 'Post-appuntamento | Altri problemi in fase avanzata',
      value: 'Post-appuntamento | Altri problemi in fase avanzata',
    },
    {
      label: "Post-appuntamento | Andato con un'altra offerta",
      value: "Post-appuntamento | Andato con un'altra offerta",
    },
    {
      label:
        'Post-appuntamento | Dilungamento su pratica o lavori  (post appuntamento)',
      value:
        'Post-appuntamento | Dilungamento su pratica o lavori  (post appuntamento)',
    },
    {
      label:
        'Post-appuntamento | Pratica bloccata dalla banca  (post appuntamento)',
      value:
        'Post-appuntamento | Pratica bloccata dalla banca  (post appuntamento)',
    },
    {
      label: 'Post-appuntamento | Non vuole pagare la provvigione',
      value: 'Post-appuntamento | Non vuole pagare la provvigione',
    },
    {
      label: 'Post-appuntamento | Ha interrotto la ricerca',
      value: 'Post-appuntamento | Ha interrotto la ricerca',
    },
  ],
};


// NOTA: per passarci il valore della motivazione va passato il valore interno in hubspot
export const DROPPED_MOTIVATION_IDS = [
  /*{ label: 'Pre-appuntamento | Bocciato subito', value: 'Pre-appuntamento | Bocciato subito' },
  { label: 'Pre-appuntamento | Non ha mai risposto', value: 'Pre-appuntamento | Non ha mai risposto' },
  { label: 'Pre-appuntamento | Non interessato', value: 'Pre-appuntamento | Non interessato' },*/
  {
    label: "Pre-appuntamento | Non si è presentato all'appuntamento",
    value: '1. 1. Pre-appuntamento | Appuntamento disdetto',
  },
  {
    label: 'Pre-appuntamento | Appuntamento disdetto',
    value: '1. 1. Pre-appuntamento | Appuntamento disdetto',
  },
  /* { label: 'Pre-appuntamento | Numero errato', value: 'Pre-appuntamento | Numero errato' },
  { label: 'Predrop', value: 'Predrop' },*/
  {
    label: 'Post-appuntamento | Appuntamento andato male (altri motivi)',
    value: '2. Post-appuntamento | Appuntamento andato male',
  },
  {
    label: 'Post-appuntamento | Requisiti bocciati',
    value: 'Requisiti non approvati',
  },
  {
    label: 'Post-appuntamento | Altri problemi in fase avanzata',
    value: 'a. Altri problemi (post appuntamento)',
  },
  {
    label: "Post-appuntamento | Andato con un'altra offerta",
    value: "3. Post-appuntamento | Andato con un'altra offerta",
  },
  {
    label:
      'Post-appuntamento | Dilungamento su pratica o lavori  (post appuntamento)',
    value: 'Dilungamento su pratica o lavori',
  },
  {
    label:
      'Post-appuntamento | Pratica bloccata dalla banca  (post appuntamento)',
    value: 'Pratica bloccata dalla banca',
  },
  {
    label: 'Post-appuntamento | Non vuole pagare la provvigione',
    value: '3. Post-appuntamento | Non vuole pagare la provvigione',
  },
  {
    label: 'Post-appuntamento | Ha interrotto la ricerca',
    value: '3. Post-appuntamento | Ha interrotto la ricerca',
  },
];
